import React from 'react';
import { Container, Header, ColumnLayout, Box } from '@amzn/awsui-components-react-v3';
import { TrendDelta } from './types';

interface TrendStripProps {
    trends: TrendDelta[];
    currentTotal?: number;
}

const arrow = (delta: number | null) => (delta == null ? '' : delta > 0 ? '▲' : delta < 0 ? '▼' : '■');
// Stuck count going up is bad (warning), down is good (success).
const color = (delta: number | null) =>
    delta == null || delta === 0 ? 'inherit' : delta > 0 ? 'text-status-warning' : 'text-status-success';

const TrendStrip: React.FC<TrendStripProps> = ({ trends, currentTotal }) => (
    <Container header={<Header variant="h2">Trend</Header>}>
        <ColumnLayout columns={(trends.length || 1) + 1} variant="text-grid">
            <div>
                <Box variant="awsui-key-label">Total stuck now</Box>
                <Box fontSize="heading-l" fontWeight="bold">{(currentTotal ?? 0).toLocaleString()}</Box>
            </div>
            {trends.map((t) => (
                <div key={t.label}>
                    <Box variant="awsui-key-label">{t.label}</Box>
                    {t.delta == null ? (
                        <Box color="text-status-inactive">collecting…</Box>
                    ) : (
                        <Box fontSize="heading-l" fontWeight="bold" color={color(t.delta)}>
                            {arrow(t.delta)} {t.delta > 0 ? '+' : ''}{t.delta.toLocaleString()}
                            <Box variant="span" fontSize="body-s" color="text-body-secondary"> ({t.pct! > 0 ? '+' : ''}{t.pct!.toFixed(1)}% vs {t.past!.toLocaleString()})</Box>
                        </Box>
                    )}
                </div>
            ))}
        </ColumnLayout>
    </Container>
);

export default TrendStrip;
